/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.getPublicQrCodeScanToken

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.getPublicQrCodeScanToken.GetPublicQrCodeScanTokenApi
import features.getPublicQrCodeScanToken.models.GetPublicQrCodeScanTokenResponseModel
import features.getPublicQrCodeScanToken.serializeGetPublicQrCodeScanTokenState
import features.getPublicQrCodeScanToken.models.PublicQrCodeScanTokenRequest

import kotlinx.serialization.decodeFromString

/**
 * Get Public QR Code Scan Token [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GetPublicQrCodeScanTokenApi")
class GetPublicQrCodeScanTokenApiJs {

    /**
     * Get Public QR Code Scan Token
     */


    
    fun getPublicQrCodeScanToken(overrideHeaders: String?,
serializedPublicQrCodeScanTokenRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = GetPublicQrCodeScanTokenApi().getPublicQrCodeScanToken(
            overrideHeaders = decodedOverrideHeaders,
                publicQrCodeScanTokenRequest = Json.decodeFromString(
                    serializedPublicQrCodeScanTokenRequest
                )
            ).toJsonResult<GetPublicQrCodeScanTokenResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeGetPublicQrCodeScanTokenState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GetPublicQrCodeScanTokenApi().getPublicQrCodeScanTokenState.serializeGetPublicQrCodeScanTokenState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
